import { toastError } from '@onestep/coreui/Toast';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export default function useInviteSmsService() {
  const inviteSMSAction = useMutation({
    mutationFn: async (data: { phoneNumber: string; patientUuid: string; force?: boolean }) => {
      await axios.post(`/api/camel/intake/${data.patientUuid}/send_invite_sms/`, {
        phoneNumber: data.phoneNumber,
        force: data?.force ?? false,
      });
    },
  });

  const inviteQRAction = useMutation({
    mutationFn: async (patientUuid: string) => {
      try {
        const result = await axios.post<{ qrBase64Png: string; code: string }>(
          `/api/camel/intake/${patientUuid}/invitation/`,
        );
        const qrBase64Png = result.data.qrBase64Png;
        const deep_link_sub1 = result.data.code;

        return {
          qrBase64Png: qrBase64Png,
          deepLinkSub1: deep_link_sub1,
        };
      } catch {
        toastError({ content: 'Failed to get invitation qr!' });
      }
    },
  });

  return {
    sendInviteSms: inviteSMSAction.mutateAsync,
    getInviteQR: inviteQRAction.mutateAsync,
  };
}
